import {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
  type ReactNode,
} from "react";

import {
  fetchRubToUsdRate,
  type ExchangeRateSource,
} from "../lib/exchangeRate";

type ExchangeRateState = {
  rubToUsd: number | null;
  loading: boolean;
  source: ExchangeRateSource | null;
};

const ExchangeRateContext = createContext<ExchangeRateState | null>(null);

export function ExchangeRateProvider({ children }: { children: ReactNode }) {
  const [state, setState] = useState<ExchangeRateState>({
    rubToUsd: null,
    loading: true,
    source: null,
  });

  useEffect(() => {
    void fetchRubToUsdRate().then(({ rate, source }) => {
      setState({ rubToUsd: rate, loading: false, source });
    });
  }, []);

  const value = useMemo(() => state, [state]);

  return (
    <ExchangeRateContext.Provider value={value}>
      {children}
    </ExchangeRateContext.Provider>
  );
}

export function useExchangeRate(): ExchangeRateState {
  const ctx = useContext(ExchangeRateContext);
  if (!ctx) {
    throw new Error("useExchangeRate must be used within ExchangeRateProvider");
  }
  return ctx;
}
